// extracted by mini-css-extract-plugin
module.exports = {"labelCardSection":"dropdown-module--labelCardSection--3I6Lh","customPopover":"dropdown-module--customPopover--1pQfr"};